import { pathAPI } from "../utils/pathApi";
import { omitEmpty } from "../utils/utils";
import { useAPI } from "./api";

export const useOrders = ({
  page = 0,
  country,
  size = 10,
  outlet_id,
  from,
  to,
  search,
}: {
  page: number;
  size: number;
  country?: string;
  outlet_id?: string;
  from?: string;
  to?: string;
  search?: string;
}) => {
  const { data, error, loading, mutate } = useAPI<{
    data: Order[];
    total: number;
  }>(
    pathAPI.orders,
    true,
    omitEmpty({ page, size, country, outlet_id, from, to, order_id: search })
  );

  return [
    {
      data: data?.data || null,
      total: data?.total || 0,
      error,
      isLoading: loading,
    },
    { mutate },
  ] as const;
};

export const useOrderDetail = ({ id }: { id?: string }) => {
  const { data, error, loading, mutate } = useAPI<{
    data: OrderDetail;
    total: number;
  }>(`${pathAPI.orders}/${id}`, true);

  return [
    {
      data: data?.data || null,
      total: data?.total || 0,
      error,
      isLoading: loading,
    },
    { mutate },
  ] as const;
};

export const useOrderCancelReasons = ({
  page = 0,
  size = 10,
}: {
  page: number;
  size: number;
}) => {
  const { data, error, loading, mutate } = useAPI<{
    data: OrderCancelReason[];
    total: number;
  }>(pathAPI.cancelReason, true, omitEmpty({ page, size }));

  return [
    {
      data: data?.data || null,
      total: data?.total || 0,
      error,
      isLoading: loading,
    },
    { mutate },
  ] as const;
};
